const fullcontKey = require('../components/fullcont/fullcont-key')

let keyupToConsume = ''

/**
 * Identifica las teclas reservadas del sistema y delega su accion.
 * Los atajos globales tienen prioridad sobre las acciones key/keyDown del elemento activo.
 * Si el atajo no aplica o el contexto no tiene un boton configurado, el evento
 * conserva su flujo normal y puede ser procesado por el data-detail del elemento.
 */
export function start(ev) {
    const pressedKey = normalizeKey(ev.key)

    // Consume el keyup correspondiente a un atajo que ya se ejecuto en keydown.
    if (ev.type === 'keyup' && keyupToConsume === pressedKey) {
        ev.preventDefault()
        keyupToConsume = ''
        return true
    }

    if (ev.type !== 'keydown') {
        return false
    }

    const action = getReservedAction(ev, pressedKey)

    if (action === '') {
        return false
    }

    // Mientras una tecla permanece presionada no debe repetir la misma accion.
    if (ev.repeat && keyupToConsume === pressedKey) {
        ev.preventDefault()
        return true
    }

    const wasHandled = fullcontKey.start({ act: action, ev: ev })

    if (wasHandled) {
        keyupToConsume = pressedKey
    }

    return wasHandled
}

function getReservedAction(ev, pressedKey) {
    if (ev.ctrlKey && pressedKey === 'enter') {
        return 'controlEnter'
    }

    if (ev.ctrlKey && pressedKey === 'p') {
        return 'controlP'
    }

    if (
        pressedKey === '+'
        && !ev.ctrlKey
        && !ev.altKey
        && !ev.metaKey
    ) {
        return 'plus'
    }

    return ''
}

function normalizeKey(key) {
    return typeof key === 'string' ? key.toLowerCase() : ''
}
